"use client";

import { c as _c } from "react/compiler-runtime";
import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui";
export default function EmailField(t0) {
  const $ = _c(11);
  const {
    className,
    required: t1
  } = t0;
  const required = t1 === undefined ? false : t1;
  const {
    register,
    formState: t2
  } = useFormContext();
  const {
    errors
  } = t2;
  const t3 = required && "Email is required";
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /^[^@]+@[^@]+$/;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== register || $[2] !== t3) {
    t5 = register("email", {
      required: t3,
      pattern: {
        value: t4,
        message: "Invalid email address"
      }
    });
    $[1] = register;
    $[2] = t3;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = !!errors.email;
  const t7 = String(errors.email?.message) || undefined;
  let t8;
  if ($[4] !== t5 || $[5] !== t6 || $[6] !== t7) {
    t8 = <Input type="email" id="email" placeholder="example@email.com" className="mt-1" {...t5} hasError={t6} errorMessage={t7} />;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== className || $[9] !== t8) {
    t9 = <div className={className}>{t8}</div>;
    $[8] = className;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}